import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0a19ebe8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "oc_detail"
}
const _hoisted_2 = { style: {"padding":"13px 15px"} }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "time" }
const _hoisted_5 = { class: "time_p" }
const _hoisted_6 = { class: "date_p" }
const _hoisted_7 = { class: "step_circle" }
const _hoisted_8 = { class: "arrow" }
const _hoisted_9 = { class: "code" }
const _hoisted_10 = { class: "shop_name" }
const _hoisted_11 = { class: "shop_code" }
const _hoisted_12 = { class: "title" }
const _hoisted_13 = { class: "details_content" }
const _hoisted_14 = {
  key: 0,
  class: "wulian"
}
const _hoisted_15 = {
  key: 0,
  class: "i-item"
}
const _hoisted_16 = { class: "i-title" }
const _hoisted_17 = { class: "text" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "i-tag" }, " 物联 ", -1))
const _hoisted_19 = { class: "i-value" }
const _hoisted_20 = { class: "item_title" }
const _hoisted_21 = {
  key: 1,
  style: {"display":"flex"}
}
const _hoisted_22 = { class: "project_name" }
const _hoisted_23 = {
  key: 3,
  class: "text_description"
}
const _hoisted_24 = {
  key: 4,
  class: "imgs"
}
const _hoisted_25 = {
  key: 5,
  class: "sign"
}
const _hoisted_26 = {
  key: 6,
  class: "text_description"
}
const _hoisted_27 = { class: "btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_divider = _resolveComponent("van-divider")!
  const _component_van_image = _resolveComponent("van-image")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_reject_open_shop_apply = _resolveComponent("reject-open-shop-apply")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    ($setup.storeInfo.data)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, "状态：" + _toDisplayString($setup.storeInfo.data.state_name), 1),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: "step",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
          _ctx.$router.push({
            name: _ctx.$RouterName.OPERATION_RECORD,
            query: {
              id: $setup.storeInfo.data.id
            }
          })
        ))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("p", _hoisted_5, _toDisplayString($setup.moment(Number($setup.storeInfo.data.opt_info?.create_time) * 1000).format("hh:mm")), 1),
                _createElementVNode("p", _hoisted_6, _toDisplayString($setup.moment(Number($setup.storeInfo.data.opt_info?.create_time) * 1000).format("YY-MM-DD")), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_van_steps, {
                  direction: "vertical",
                  active: "0",
                  "active-icon": "circle",
                  "active-color": "#3d6eeb"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_van_step, null, {
                      default: _withCtx(() => [
                        _createElementVNode("h3", null, [
                          _createTextVNode(_toDisplayString($setup.storeInfo.data.opt_info?.user_info?.name) + " ", 1),
                          _createElementVNode("span", null, _toDisplayString($setup.storeInfo.data.opt_info?.log), 1)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_van_step)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_van_icon, { name: "arrow" })
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, _toDisplayString($setup.storeInfo.data.title), 1),
              _createElementVNode("div", _hoisted_11, _toDisplayString($setup.storeInfo.data.code), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.data.oc_json_arr, (json) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "details",
                key: json.oc_json_id
              }, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(json.title), 1),
                _createVNode(_component_van_divider),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", null, _toDisplayString(json.user_name) + " 提交于 " + _toDisplayString(json.create_time_name), 1),
                  ($setup.storeInfo.data.iot_params?.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.data.iot_params, (item, index) => {
                          return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                            (item.is_show === '1')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                  _createElementVNode("div", _hoisted_16, [
                                    _createElementVNode("span", _hoisted_17, _toDisplayString(item.energy_type_name) + _toDisplayString(item.title), 1),
                                    _hoisted_18
                                  ]),
                                  _createElementVNode("div", _hoisted_19, _toDisplayString(item.iot_params_value.param_value) + _toDisplayString(item.iot_params_value.param_unit), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(json.oc_json, (component) => {
                    return (_openBlock(), _createElementBlock(_Fragment, {
                      key: component.sort
                    }, [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(component.title) + ":", 1),
                      (component.check_type === 'check_radio')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            class: _normalizeClass([component.isWarning === '1' ? 'num_red' : '', "project_name"])
                          }, _toDisplayString(component.fieldValue), 3))
                        : _createCommentVNode("", true),
                      (component.check_type === 'check_checkbox')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                            _createElementVNode("div", _hoisted_22, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.fieldValue, (span, index) => {
                                return (_openBlock(), _createElementBlock("span", {
                                  class: _normalizeClass(span.isWarning === '1' ? 'num_red' : ''),
                                  key: index
                                }, _toDisplayString(span.value) + ", ", 3))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (component.check_type === 'check_number')
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 2,
                            class: _normalizeClass(
                  Number(component.result) > Number(component.max_value) ||
                  Number(component.result) < Number(component.min_value)
                    ? 'num_red'
                    : ''
                )
                          }, _toDisplayString(component.result) + _toDisplayString(component.unit), 3))
                        : _createCommentVNode("", true),
                      (component.check_type === 'check_textarea')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_23, _toDisplayString(component.result), 1))
                        : _createCommentVNode("", true),
                      (component.check_type === 'check_pic')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(component.pic_arr, (pic) => {
                              return (_openBlock(), _createBlock(_component_van_image, {
                                key: pic.id,
                                width: "100",
                                height: "100",
                                src: pic.photo_thumb_file
                              }, null, 8, ["src"]))
                            }), 128))
                          ]))
                        : _createCommentVNode("", true),
                      (component.check_type === 'check_assign')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                            _createVNode(_component_van_image, {
                              width: "100%",
                              height: "100%",
                              src: component.pic_arr?.[0].photo_thumb_file
                            }, null, 8, ["src"])
                          ]))
                        : _createCommentVNode("", true),
                      (component.check_type === 'check_show')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, _toDisplayString(component.content), 1))
                        : _createCommentVNode("", true),
                      _createVNode(_component_van_divider)
                    ], 64))
                  }), 128)),
                  _createVNode(_component_van_divider)
                ])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_27, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.storeInfo.data.opt_lists, (opt, index) => {
              return (_openBlock(), _createBlock(_component_van_button, {
                style: _normalizeStyle({ marginRight: index === 0 ? '10px' : '' }),
                key: opt.type,
                plain: opt.type == 3,
                type: "primary",
                block: "",
                onClick: ($event: any) => ($setup.optClick(opt.type))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(opt.name), 1)
                ]),
                _: 2
              }, 1032, ["style", "plain", "onClick"]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_reject_open_shop_apply, {
      show: $setup.rejectOpenShopApplyInfo.show,
      "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => (($setup.rejectOpenShopApplyInfo.show) = $event)),
      option: $setup.rejectOpenShopApplyInfo.option,
      onSubmit: $setup.rejectOpenShopApplyInfo.onSubmit
    }, null, 8, ["show", "option", "onSubmit"])
  ], 64))
}